











import Vue, { PropType } from 'vue'
import { ValorPMultiSelect } from 'src/tipos'
import { mapState } from 'vuex'

type ItemId = string

interface Item {
  id: ItemId;
}

type TipoObservavel = 'locaisDeTrabalhoObservados' | 'funcionariosObservados' | 'gruposDeUsuarioObservados'

interface Computed {
  valueInterno: ValorPMultiSelect;
  itens: Item[];
  locaisDeTrabalhoObservados: Item[];
  funcionariosObservados: Item[];
  gruposDeUsuarioObservados: Item[];
}

interface Props {
  value: ItemId[];
  tipoObservado: TipoObservavel;
}

export default Vue.extend<{}, {}, Computed, Props>({
  name: 'SobreQuemSeraObservado',

  props: {
    value: {
      type: Array as PropType<ItemId[]>,
      required: true
    },

    tipoObservado: {
      type: String as PropType<TipoObservavel>,
      required: true
    }
  },

  computed: {
    ...mapState('common/companies', {locaisDeTrabalhoObservados: 'items'}),

    ...mapState('common/employees', {funcionariosObservados: 'items'}),

    ...mapState('common/userGroups', {gruposDeUsuarioObservados: 'items'}),

    itens (): Item[] {
      const opcoesObservaveis = {
        locaisDeTrabalhoObservados: this.locaisDeTrabalhoObservados,
        funcionariosObservados: this.funcionariosObservados,
        gruposDeUsuarioObservados: this.gruposDeUsuarioObservados
      }
      return opcoesObservaveis[this.tipoObservado]
    },

    valueInterno: {
      get (): ValorPMultiSelect {
        const listaDeIdsDosItensSelecionados = this.value

        function verificarSeIdDoItemEstaNaListaDeSelecionados (item: Item): boolean {
          return listaDeIdsDosItensSelecionados.includes(item.id)
        }

        const listaDeTodosOsItens = this.itens
        const itensSelecionados = listaDeTodosOsItens.filter(verificarSeIdDoItemEstaNaListaDeSelecionados)

        const opcoesFormatadasDoSeletor = {
          selected: itensSelecionados,
          loaded: listaDeTodosOsItens
        }

        return opcoesFormatadasDoSeletor
      },
      set (valueInternoAtualizado: ValorPMultiSelect): void {
        function pegarIdDoItem (item: Item): ItemId {
          return item.id
        }

        const itensSelecionados = valueInternoAtualizado.selected as Item[]
        const listaDeIdsDosItensSelecionados = itensSelecionados.map(pegarIdDoItem)

        this.$emit('input', listaDeIdsDosItensSelecionados)
      }
    }
  }
})
